module.exports = __webpack_public_path__ + "img/01-Customer-Process.3b957798.svg";